import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'

import moment from 'moment'

import { Integration as IntegrationModel } from 'lib/models/Integration'

import microsoft365Logo from '../../../images/microsoft365Logo.png'

import { 
    Button,
    Dialog,
    TextField,
    DialogTitle,
    DialogContent,
    InputAdornment,
    CircularProgress
} from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

import Alert from '@material-ui/lab/Alert'

import CloseIcon from '@material-ui/icons/Close'
import CheckCircle from '@material-ui/icons/CheckCircle'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import RemoveRedEye from '@material-ui/icons/RemoveRedEye'
import VisibilityOff from '@material-ui/icons/VisibilityOff'


import DotProgress from '../../Components/DotProgress'
import SearchableListDialog from '../../Components/SearchableListDialog'
import MoreDetectionCoverageDialog from '../../Components/MoreDetectionCoverageDialog'

import { secondaryConnectionSteps, tertiaryConnectionSteps, quaternaryConnectionSteps } from './constants'

import { getOrgs } from 'redux/actions/Org'
import { loadPageData } from 'redux/actions/Request'

import { INTEGRATION_STATUS } from '../CloudModules/constants'

const ms365IntegrationType = "o365/Initialize"

const useStyles = makeStyles((theme) => ({
    pageContainer: {
        padding: '0px 30px'
    },
    pageTitleContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: `${theme.shape.padding}px 0`
    },
    pageTitle: {
        fontSize: 40,
        marginBottom: theme.shape.padding,
        fontWeight: 'bold'
    },
    stepsContainer: {
        width: '100%',
        marginBottom: theme.shape.padding
    },
    image: {
        width: 120
    },
    connectButton: {
        padding: theme.shape.padding,
        marginBottom: 10
    },
    onboardingStep: {
        width: '33%',
        height: 320,
        padding: '15px 30px',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'space-between',
        borderRadius: theme.shape.borderRadius,
        border: `2px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper
    },
    connectStepContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    stepNumberContainer: {
        position: 'relative'
    },
    completed: {
        top: 10,
        right: -5,
        zIndex: 999,
        fontSize: 25,
        position: 'absolute',
        color: theme.palette.success.main,
        backgroundColor: theme.palette.background.paper
    },
    loading: {
        top: 10,
        right: -5,
        zIndex: 999,
        borderRadius: 15,
        position: 'absolute',
        backgroundColor: theme.palette.background.paper
    },
    stepNumber: {
        width: 70,
        height: 70,
        padding: 0,
        display: 'flex',
        borderRadius: 35,
        fontWeight: 'bold',
        alignItems: 'center',
        justifyContent: 'center',
        border: `3px solid ${theme.palette.divider}`,
        '& p': {
            padding: 10,
            fontSize: 35,
            marginBottom: 0
        }
    },
    titleContentContainer: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    stepTitle: {
        fontWeight: 'bold'
    },
    subsequentStepText: {
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: theme.shape.padding
    },
    span: {
        fontSize: 15,
        marginTop: theme.shape.padding,
        color: theme.palette.text.secondary
    },
    microsoftBlumiraImgContainer: {
        padding: '15px 0',
        wiidth: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
    },
    microsoftBlumiraImg: {
        width: '80%'
    },
    learnMoreVideoContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between'
    },
    sectionTitle: {
        fontSize: 18,
        fontWeight: 'bold'
    },
    learnMoreSectionContainer: {
        padding: 30,
        flexDirection: 'column'
    },
    learnMoreLinkContainer: {
        display: 'flex',
        flexDirection: 'column',
        '& a': {
            paddingBottom: theme.shape.padding,
            color: theme.palette.primary.main
        }
    },
    linkContainer: {
        display: 'flex',
        '& p': {
            marginLeft: theme.shape.padding * 2
        }
    },
    linkButton: {
        padding: 10,
        cursor: 'pointer',
        color: theme.palette.common.white,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.primary.main
    },
    link: {
        cursor: 'pointer',
        color: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.primary.main,
            textDecoration: 'underline'
        },
    },
    videoSectionContainer: {
        padding: 30,
        marginLeft: theme.shape.padding
    },
    disclaimerText: {
        fontSize: 10,
        paddingTop: theme.shape.padding
    },
    dialogHeaderContainer: {
        display: 'flex',
        paddingRight: 30,
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: `1px solid ${theme.palette.divider}`
    },
    dialogContent: {
        padding: 30
    },
    headerCtaContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        '& p': {
            marginBottom: 0,
            paddingRight: theme.shape.padding
        },
        '& a': {
            paddingRight: theme.shape.padding
        },
    },
    ruleContainer: {
        display: 'flex',
        flexDirection: 'column'
    },
    dialogFooter: {
        padding: 30,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        borderTop: `1px solid ${theme.palette.divider}`
    },
    close: {
        cursor: 'pointer'
    },
    list: {
        paddingLeft: 20,
        marginBottom: 0
    },
    listItem: {
        paddingBottom: theme.shape.padding
    },
    textFieldContainer: {
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: 20,
        paddingRight: 20
    },
    textField: {
        width: '100%',
        marginBottom: theme.shape.padding
    },
    successContainer: {
        width: 500,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        '& p': {
            marginBottom: theme.shape.padding
        }
    },
    checkCircle: {
        fontSize: 50,
        marginBottom: theme.shape.padding,
        color: theme.palette.success.main
    },
    connectionDialogContainer: {
        minHeight: 500
    },
    buttonContainer: {
        zIndex: 999,
        paddingBottom: theme.shape.padding * 2
    },
    dotProgressContainer: {
        bottom: 30,
        width: '100%',
        display: 'flex',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center'
    },
    alert: {
        marginTop: -theme.shape.padding,
        marginBottom: theme.shape.padding
    }
}))

const OnboardingStep = props => {
    const classes = useStyles()

    return (
        <div 
            className={classes.onboardingStep} 
            style={{
                // leverage percentage to maintain 
                // styling when menu is opened/closed
                zIndex: 10/props.step,
                width: props.step === 1 ? '40%' : '35%',
                marginTop: props.step > 1 ? -320 : 0,
                paddingLeft: props.step === 2 ? '4%' : props.step === 3 ? '8%' : 15,
                marginLeft: props.step === 1 ? 0 : props.step === 2 ? '37%' : '65%'
            }}
        >
            <div className={classes.stepNumberContainer}>
                {props.completed ? 
                    <CheckCircle className={classes.completed} />
                : props.loading ?
                    <CircularProgress size={20} className={classes.loading} />
                : null
                }
                <div className={classes.stepNumber}><p>{props.step}</p></div>
            </div>
            <div className={classes.titleContentContainer}>
                <div className={classes.stepTitle}>{props.title}</div>
                {props.content}
            </div>
            {props.cta ? props.cta : <div/>}
        </div>
    )
}

const WelcomePageView = props => {
    const classes = useStyles()

    const [clientId, setClientId] = useState('')
    const [tenantId, setTenantId] = useState('')
    const [isSaving, setIsSaving] = useState(false)
    const [clientSecret, setClientSecret] = useState('')
    const [connectStep, setConnectStep] = useState(1)
    const [errorMessage, setErrorMessage] = useState('')
    const [hasIntegration, setHasIntegration] = useState(false)
    const [m365Integration, setM365Integration] = useState(null)
    const [isButtonDisabled, setIsButtonDisabled] = useState(false)
    const [areRulesDeployed, setAreRulesDeployed] = useState(false)
    const [isOrgNameDialogOpen, setIsOrgNameDialogOpen] = useState(false)
    const [isConnectDialogOpen, setIsConnectDialogOpen] = useState(false)
    const [isDetectionRulesDialogOpen, setIsDetectionRulesDialogOpen] = useState(false)
    const [isDetectionCoverageDialogOpen, setIsDetectionCoverageDialogOpen] = useState(false)

    const [secretIsMasked, setSecretIsMasked] = useState(true)
    const [maskedInputIndexes, setMaskedInputIndexes] = useState([0, 1, 2]) // default secrets to hidden

    useEffect(() => {
        if(!props.currentOrg){
            props.getOrgs()
        }
        if(props.currentOrg && props.currentOrg.name.toLowerCase().includes('sandbox'))
            setIsOrgNameDialogOpen(true)
        props.reload(true)
    }, [props.currentOrg]) /* eslint-disable-line */

    useEffect(() => {
        if(props.integrations){
            const existingM365Integration = props.integrations.find(integration => integration.integrationType === ms365IntegrationType)
            setM365Integration(existingM365Integration)
            setHasIntegration(!!existingM365Integration)
        }
    }, [props.integrations])

    useEffect(() => {
        if(props.rules){
            setAreRulesDeployed(!!props.rules.length)
        }
    }, [props.rules])

    const toggleDetectionRulesDialog = () => {
        setIsDetectionRulesDialogOpen(!isDetectionRulesDialogOpen)
    }

    const toggleDetectionCoverageDialog = () => {
        setIsDetectionCoverageDialogOpen(!isDetectionCoverageDialogOpen)
    }

    const toggleConnectDialog = () => {
        setIsConnectDialogOpen(!isConnectDialogOpen)
        setClientId('')
        setTenantId('')
        setConnectStep(1)
        setClientSecret('')
        setErrorMessage('')
        if (connectStep === 5) {
            props.reload(true)
        }
    }

    const handleGetMoreClick = () => {
        setIsDetectionRulesDialogOpen(false)
        setIsDetectionCoverageDialogOpen(true)
    }

    const handleConnect = () => {
        const timeStamp = moment().format('MM/DD/YYYY').replace(/\//g, '-')
        const integration = new IntegrationModel({
            integrationName: `Microsoft 365 Cloud Connector ${timeStamp}`,
            integrationType: 'o365/Initialize',
            configuration: {},
            secret: {
             client_id: clientId,
             tenant_id: tenantId,
             client_secret: clientSecret
            }
        })

        // TODO: add in org creation here 
        // prior to integration creation
        integration.create()
        .then(() => {
            setConnectStep(5)
            // if successful display UI
            // completion markers in step
            setHasIntegration(true)
            setIsButtonDisabled(false)
        })
        .catch(e => {
            setErrorMessage('Oops, there was an issue creating your cloud connector. Please double check your secrets and try again.')
            setIsButtonDisabled(false)
        })
    }

    const handleNextConnectStep = (e) => {
        e.preventDefault()

        setIsButtonDisabled(true)

        if(connectStep === 2 && (!clientId || !tenantId)){
            setIsButtonDisabled(false)
            return setErrorMessage('Please enter an Application and Directory ID to continue')
        }
        else if(connectStep === 4 && !clientSecret){
            setIsButtonDisabled(false)
            return setErrorMessage('Please enter a Client Secret to continue')
        }

        setErrorMessage('')

        let nextStep = connectStep + 1

        if(connectStep === 4)
            return handleConnect()

        setConnectStep(nextStep)
        setIsButtonDisabled(false)
    }

    const handleBackConnectStep = () => {
        setErrorMessage('')
        setConnectStep(connectStep - 1)
    }

    const handleGoToSummaryDashboard = () => {
        props.goToSummaryDashboardView()
    }

    const handleClientIdChange = event => {
        setClientId(event.target.value)
    }

    const handleTenantIdChange = event => {
        setTenantId(event.target.value)
    }

    const handleClientSecretChange = event => {
        setClientSecret(event.target.value)
    }

    const toggleMask = inputIndex => {
        const foundInputIndex = maskedInputIndexes.find(i => i === inputIndex)
        const newMaskedInputIndexes = foundInputIndex > -1 ? [...maskedInputIndexes].filter(i => i !== foundInputIndex) : [...maskedInputIndexes].concat([inputIndex])
        setMaskedInputIndexes(newMaskedInputIndexes)
        setSecretIsMasked(!secretIsMasked)
    }

    const isInputMasked = inputIndex => {
        return maskedInputIndexes.find(i => i === inputIndex) > -1
    }

    const isOnboaordingStepTwoComplete = () => {
        // user has rules deployed and
        // integration created and 
        // integration status is 'ok'
        if(areRulesDeployed && m365Integration && (m365Integration.integrationStatus === INTEGRATION_STATUS.OK))
            return true
        return false
    }

    /* 
        note that a user will need to refresh
        this page as we are not polling for rules 
    */
    const isOnboaordingStepTwoLoading = () => {
        // user has no rules deployed or
        // integration created and 
        // status is anything but 'ok'
        if((hasIntegration && !areRulesDeployed) || (m365Integration && (m365Integration.integrationStatus !== INTEGRATION_STATUS.OK)))
            return true
        return false
    }

    const handleOrgNameChange = e => {
        if(!props.currentOrg)
            return
        props.currentOrg.set({ name: e.target.value })
    }

    const handleSaveOrg = async () => {
        setIsSaving(true)
        await props.currentOrg.update()
        await props.getOrgs()
        toggleOrgNameDialog()
        setIsSaving(false)
    }

    const toggleOrgNameDialog = () => {
        setIsOrgNameDialogOpen(!isOrgNameDialogOpen)
    }

    return (
        <div className={classes.pageContainer}>
            <div className={classes.pageTitleContainer}>
                <p className={classes.pageTitle}>Welcome to Blumira!</p>
                <div className={classes.linkContainer}>
                    <p className={classes.link} onClick={toggleDetectionRulesDialog}>
                        What does Blumira detect?
                    </p>
                    <p className={classes.link} onClick={toggleDetectionCoverageDialog}>
                        How do I get more detection coverage?
                    </p>
                </div>
            </div>
            <div className={classes.stepsContainer} datacy={'onboardingStepContainer'}>
                <OnboardingStep
                    step={1}
                    completed={hasIntegration}
                    title={<span>Connect to <img src={microsoft365Logo} className={classes.image} alt={'M365'} /></span>}
                    content={
                        <div>
                            <p className={classes.subsequentStepText}>Blumira's Free Edition connects to and detects Microsoft 365 security events.</p>
                        </div>
                    }
                    cta={!hasIntegration ?
                        <Button className={classes.connectButton} variant={'contained'} color={'primary'} onClick={toggleConnectDialog} datacy={'connectToM365Button'}>
                            Connect to Microsoft 365
                        </Button>
                        : null
                    }
                />
                <OnboardingStep
                    step={2}
                    title={isOnboaordingStepTwoLoading() ? 'Importing logs' : 'Import logs'}
                    loading={isOnboaordingStepTwoLoading()}
                    completed={isOnboaordingStepTwoComplete()}
                    content={
                        isOnboaordingStepTwoLoading() ?
                        <p className={classes.subsequentStepText}>
                            We're importing your Microsoft 365 logs and applying pre-tuned detection rules.
                            <span className={classes.span}>This may take several mintues.</span>
                        </p>
                        : <p className={classes.subsequentStepText}>
                            We imported your Microsoft 365 logs and applied pre-tuned detection rules.
                        </p>
                    }
                />
                <OnboardingStep
                    step={3}
                    title={'Review findings'}
                    content={<p className={classes.subsequentStepText}>You'll then be able to review security findings and respond using playbooks.</p>}
                    cta={isOnboaordingStepTwoComplete() ?
                        <Button className={classes.connectButton} variant={'contained'} color={'primary'} onClick={handleGoToSummaryDashboard} dataCy={'viewSummaryDashboardBtn'}>
                            View Summary Dashboard
                        </Button>
                        : null
                    }
                />
            </div>
            <div className={classes.learnMoreVideoContainer}>
                <div className={classes.learnMoreSectionContainer}>
                    <div>
                        <p className={classes.sectionTitle}>How does Blumira work?</p>
                        <p>
                            Blumira’s platform identifies security threats across your environment by importing logs from your 
                            data sources, applying pre-tuned detection rules, then guiding you through next steps for response.
                        </p>
                    </div>
                    <div className={classes.learnMoreLinkContainer}>
                        <p className={classes.sectionTitle}>Learn more</p>
                        <a href={'https://blumira.help/fgetstarted'} target={'_blank'} rel={'noopener noreferrer'}>Getting started guide <OpenInNewIcon /></a>
                        <a href={'https://blumira.help/center'} target={'_blank'} rel={'noopener noreferrer'}>Help Center<OpenInNewIcon /></a>
                        <a href={'https://www.blumira.com/webinars/'} target={'_blank'} rel={'noopener noreferrer'}>On-demand webinars <OpenInNewIcon /></a>
                        <a href={'https://www.blumira.com/whitepapers/'} target={'_blank'} rel={'noopener noreferrer'}>Whitepapers <OpenInNewIcon /></a>
                        <a href={'https://www.blumira.com/blog/'} target={'_blank'} rel={'noopener noreferrer'}>Blog <OpenInNewIcon /></a>
                    </div>
                </div>
                <div className={classes.videoSectionContainer}>
                    {/* TODO: when we eventually get a relvant video we can include it here */}
                    {/* <p className={classes.sectionTitle}>Video demo</p>
                    <iframe 
                        width={'750'}
                        height={'350'}
                        frameBorder={'0'} 
                        src={'https://www.youtube.com/embed/YIWSEa5U9_U'}
                    /> */}
                </div>
            </div>

            <SearchableListDialog 
                items={props.rules}
                title={'Detection rules'}
                open={isDetectionRulesDialogOpen}
                onClose={toggleDetectionRulesDialog}
                handleGetMoreClick={handleGetMoreClick}
                emptyText={'Detection rules will appear as soon as Blumira processes your incoming log data. This can take up to 60 minutes after you set up your first Cloud Connector or Sensor.'}
            />
            <MoreDetectionCoverageDialog 
                open={isDetectionCoverageDialogOpen}
                onClose={toggleDetectionCoverageDialog}
            />
            <Dialog open={isConnectDialogOpen} onClose={toggleConnectDialog} dataCy={'connectToM365Modal'}>
                <div className={classes.connectionDialogContainer}>
                    <div className={classes.dialogHeaderContainer}>
                        <DialogTitle>Connect to Microsoft 365</DialogTitle>
                        <div className={classes.headerCtaContainer}>
                            <a className={classes.link} href={'https://blumira.zendesk.com/hc/en-us/articles/4413368006291-Integrating-with-Microsoft-365'} target={'_blank'} rel={'noopener noreferrer'}>Get help <OpenInNewIcon /></a>
                            <CloseIcon className={classes.close} onClick={toggleConnectDialog} />
                        </div>
                    </div>
                    <DialogContent className={classes.dialogContent}>
                        {errorMessage &&
                            <Alert className={classes.alert} severity={'warning'}>{errorMessage}</Alert>
                        }
                        {connectStep === 2 ? 
                        <div>
                            <ol className={classes.list}>
                                {secondaryConnectionSteps.map(({text}, index) => (
                                    <li key={index} className={classes.listItem}>{text}</li>
                                ))}
                            </ol>
                            <div className={classes.textFieldContainer}>
                                <TextField 
                                    value={clientId}
                                    className={classes.textField}
                                    label={'Application (client) ID'}
                                    onChange={handleClientIdChange}
                                    inputProps={isInputMasked(0) ? {
                                        style: {
                                            fontFamily: 'text-security-disc'
                                        }
                                    } : {}}
                                    InputProps={{
                                        disableUnderline: true,
                                        endAdornment: (
                                            <InputAdornment style={{ cursor: 'pointer' }} position={'end'} onClick={() => toggleMask(0)}>
                                            {isInputMasked(0) ? <RemoveRedEye /> : <VisibilityOff />}
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <TextField 
                                    value={tenantId}
                                    className={classes.textField}
                                    label={'Directory (tenant) ID'}
                                    onChange={handleTenantIdChange}
                                    inputProps={isInputMasked(1) ? {
                                        style: {
                                            fontFamily: 'text-security-disc'
                                        }
                                    } : {}}
                                    InputProps={{
                                        disableUnderline: true,
                                        endAdornment: (
                                            <InputAdornment style={{ cursor: 'pointer' }} position={'end'} onClick={() => toggleMask(1)}>
                                            {isInputMasked(1) ? <RemoveRedEye /> : <VisibilityOff />}
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                        </div>
                        :
                        connectStep === 3 ?
                        <ol className={classes.list}>
                            {tertiaryConnectionSteps.map(({text}, index) => (
                                <li key={index} className={classes.listItem}>{text}</li>
                            ))}
                        </ol>
                        :
                        connectStep === 4 ?
                        <div>
                            <ol className={classes.list}>
                                {quaternaryConnectionSteps.map(({text}, index) => (
                                    <li key={index} className={classes.listItem}>{text}</li>
                                ))}
                            </ol>
                            <div className={classes.textFieldContainer}>
                                <TextField 
                                    value={clientSecret}
                                    label={'Client Secret "Value"'}
                                    className={classes.textField}
                                    onChange={handleClientSecretChange}
                                    inputProps={isInputMasked(2) ? {
                                        style: {
                                            fontFamily: 'text-security-disc'
                                        }
                                    } : {}}
                                    InputProps={{
                                        disableUnderline: true,
                                        endAdornment: (
                                            <InputAdornment style={{ cursor: 'pointer' }} position={'end'} onClick={() => toggleMask(2)}>
                                            {isInputMasked(2) ? <RemoveRedEye /> : <VisibilityOff />}
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                        </div>
                        :
                        connectStep === 5 ?
                        <div className={classes.successContainer}>
                            <CheckCircle className={classes.checkCircle} />
                            <p>Successfully connected!</p>
                            <Button variant={'contained'} color={'primary'} onClick={toggleConnectDialog}>Done</Button>
                        </div>
                        :
                        <ol className={classes.list}>
                            <li key={1} className={classes.listItem}>
                                Confirm that you are a Global Admin in Microsoft 365. If you are not a Global Admin, you will not be able to send logs to Blumira.
                            </li>
                            <li key={2} className={classes.listItem}>
                                <a rel={'noopener noreferrer'} href={'https://docs.microsoft.com/en-us/microsoft-365/compliance/turn-audit-log-search-on-or-off?view=o365-worldwide#use-the-compliance-center-to-turn-on-auditing'} target={'_blank'} className={classes.link}>
                                    Enable auditing <OpenInNewIcon /></a> for your organization in your compliance settings.
                            </li>
                            <li key={3} className={classes.listItem}>
                                Open <a rel={'noopener noreferrer'} href={'https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/Overview'} target={'_blank'} className={classes.link}>Azure Active Directory Portal <OpenInNewIcon /></a> in a separate browser window. Then place this new window next to your Blumira window to make setup easier.
                            </li>
                            <li key={4} className={classes.listItem}>
                                <a href="#" className={classes.link} onClick={handleNextConnectStep}>Continue to next step</a> {/* eslint-disable-line */}
                            </li>
                        </ol>
                        }
                        {(connectStep > 1 && connectStep < 5) &&
                        <div className={classes.buttonContainer}>
                            <Button disabled={isButtonDisabled} variant={'text'} color={'primary'} onClick={handleBackConnectStep}>Back</Button>
                            <Button disabled={isButtonDisabled} variant={'contained'} color={'primary'} onClick={handleNextConnectStep}>Continue</Button>
                        </div>
                        }
                    </DialogContent>
                    <div className={classes.dotProgressContainer}>
                        <DotProgress stepsLength={5} stepsCompleted={connectStep} />
                    </div>
                </div>
            </Dialog>
            <Dialog open={isOrgNameDialogOpen}>
                <DialogTitle>What is the name of your organization?</DialogTitle>
                <DialogContent>
                    <TextField 
                        className={classes.textField}
                        onChange={handleOrgNameChange}
                        InputProps={{ disableUnderline: true }}
                    />
                    <div className={classes.buttonContainer}>
                        <Button disabled={isSaving} variant={'text'} color={'primary'} onClick={toggleOrgNameDialog}>Not Now</Button>
                        <Button disabled={isSaving} variant={'contained'} color={'primary'} onClick={handleSaveOrg}>
                            {isSaving ? 'Saving...' : 'Submit'}
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    )
}

WelcomePageView.propTypes = { 
    goToSummaryDashboardView: PropTypes.func.isRequired
}

WelcomePageView.defaultProps = { }

const mapStateToProps = (state) => {
    const orgId = state.location.payload.orgId
    const currentOrg = state.org.listOrgs.orgs.find(o => o['id'] === orgId)
    return { currentOrg }
}

const mapDispatchToProps = (dispatch, { orgId }) => ({ 
    goToSummaryDashboardView: () => {
        const payload = {
            orgId,
            toplevel: 'dashboard',
            secondlevel: 'summary'
        }

        dispatch({
            type: 'PAGE',
            payload
        })
    },
    reload: (force) => dispatch(loadPageData(force)),
    getOrgs: () => dispatch(getOrgs())
})

export default connect(mapStateToProps, mapDispatchToProps)(WelcomePageView)
